import type { BulkCreateConflictItem } from "@/modules/classes/domain/repo/sessions/bulk-create";

export class SellPartnerScheduleHttpError extends Error {
  readonly conflictingDates: BulkCreateConflictItem[];

  constructor(conflictingDates: BulkCreateConflictItem[]) {
    super("PARTNER_SCHEDULE_CONFLICT");
    this.name = "SellPartnerScheduleHttpError";
    this.conflictingDates = conflictingDates;
  }
}
